export function handleSearch(searchInput: string, value: string): boolean {
  const input: string = searchInput
    .trim()
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/[\s\-_]+/g, "[\\s\\-_]+");
  const result: boolean = new RegExp(input, "i").test(value);

  return result;
}
